<template>
<div>
<navbar></navbar>
  <div class=" blocco h100 w80">  

  <div class="grid">
  <label>Nome e Cognome</label>
  <input v-bind:class="{warning : profile.name === ''}" type="text" name="name" v-model="profile.name">
  <label>Indirizzo Email</label>
  <input v-bind:class="{warning : profile.email === ''}" type="text" name="email" v-model="profile.email">
  <label>Indirizzo</label>
  <input v-bind:class="{warning : profile.address === ''}" type="text" name="address" v-model="profile.address">
  <label>Cap</label>
  <input v-bind:class="{warning : profile.cap === ''}" type="text" name="cap" v-model="profile.cap">
  <label>Citta</label>
  <input v-bind:class="{warning : profile.city === ''}" type="text" name="city" v-model="profile.city">
  <label>Telefono</label>
  <input v-bind:class="{warning : profile.phone === ''}" type="text" name="phone" v-model="profile.phone">
  <label>Codice fiscale</label>
  <input v-bind:class="{warning : profile.vat === ''}" type="text" name="vat" v-model="profile.vat">
  <div class="spacer xs"></div>
  <button v-on:click="updateUser()" class="btn btn-yellow">aggiorna dati</button>
  </div>

  <div class="spacer sm"></div>

  <circle4 v-if="loading"></circle4>

  </div>

</div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import {Circle4} from 'vue-loading-spinner'
  // import { required, minLength } from 'vuelidate/lib/validators'
  export default {
    name: 'scontrini',
    props: ['auth', 'authenticated', 'bill'],
    data () {
      return {
        profile: '',
        loading: false
      }
    },
    // validations: {
    //   name: {
    //     required,
    //     minLength: minLength(4)
    //   },
    //   vat: {
    //     required,
    //     minLength: minLength(16)
    //   }
    // },
    components: {
      Navbar,
      Circle4
    },
    methods: {
      getUser () {
        // console.log('hotelid: ' + this.hotelid)
        // console.log(localStorage)
        this.profile = JSON.parse(localStorage.profile)
        this.$http
          .get('http://drop3.drophost.it:44534/bills',
          // .get('http://localhost:44534/bills',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            this.bills = data.body.bills
            console.log(data)
          }, (error) => {
            console.log(error)
          })
      },
      updateUser: function () {
        this.loading = true
        this.$http
          .post('http://drop3.drophost.it:44534/user/update', { user: this.profile },
          // .post('http://localhost:44534/user/update', { user: this.profile },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          }
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            localStorage.profile = JSON.stringify(this.profile)
            console.log(JSON.stringify(this.profile))
            console.log(data.body)
            this.loading = false
            this.$notify({
              group: 'foo',
              title: 'Userdata updated',
              type: 'success',
              duration: 5000
            })
          }, (error) => {
            console.log(error)
          })
      }
    },
    beforeMount () {
      this.getUser()
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/Settings.vue